import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './routes/login/login.component';
import { FormGeneratorComponent } from '../common-shared/forms';

const routes: Routes = [
  {
    path: 'email-action',
    loadChildren: () =>
      import('./routes/email-action/email-action.module').then(
        (m) => m.EmailActionModule,
      ),
  },
  {
    path: 'panel',
    loadChildren: () =>
      import('./routes/panel/panel.module').then((m) => m.PanelModule),
  },

  /*{
    path: 'dashboard',
    loadChildren: () =>
      import('./routes/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: 'environments',
    loadChildren: () =>
      import('./routes/environments/environments.module').then(
        (m) => m.EnvironmentsModule,
      ),
  },
  {
    path: 'tenant-admin',
    loadChildren: () =>
      import('./routes/tenant-admin/tenant-admin.module').then(
        (m) => m.TenantAdminModule,
      ),
  },
  {
    path: 'apps',
    loadChildren: () =>
      import('./routes/apps/apps.module').then((m) => m.AppsModule),
  },
  {
    path: 'flows',
    loadChildren: () =>
      import('./routes/flows/flows.module').then((m) => m.FlowsModule),
  },
  {
    path: 'compliance',
    loadChildren: () =>
      import('./routes/compliance/compliance.module').then(
        (m) => m.ComplianceModule,
      ),
  },
  {
    path: 'form-generator',
    component: FormGeneratorComponent,
  },*/

  {
    path: 'login',
    component: LoginComponent,
  },

  /*{
    path: 'login-msal',
    component: LoginMsalComponent,
    canActivate: [MsalGuard],
  },*/
  /*{
    path: 'login2',
    component: MsalRedirectComponent,
  },*/
  { path: '**', redirectTo: 'panel', pathMatch: 'full' },
  // {path: '', loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule)},
  /*{path: '', loadChildren: () => import('./project/project.module').then(m => m.ProjectModule)},
  {path: '**', redirectTo: '', pathMatch: 'full'},*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
